<script lang="ts">
  /**
   * LOADING SPINNER — Reusable across the app.
   * Usage: <LoadingSpinner size="lg" />
   */
  interface Props {
    size?: 'sm' | 'md' | 'lg';
  }
  let { size = 'md' }: Props = $props();

  const sizeMap = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12' };
</script>

<div class="flex items-center justify-center" role="status" aria-label="Loading">
  <div class="{sizeMap[size]} border-3 border-surface-600 border-t-brand-400 rounded-full animate-spin"></div>
</div>
